<template>
    <div class="add-fabric">
        <div class="add-body">
            <Icon type="md-close" class="close-btn" @click="onClose" />
            <div class="body-title">{{material ? '编辑' : '添加'}}{{ title }}</div>
            <div class="body-content">
                <div class="body-form">
                    <Upload action="/" :before-upload="onBeforeUpload">
                        <div class="upload-main-img">
                            <img v-if="form.image" :src="form.image" alt="" class="main-img">
                            <template v-else>
                                <img src="../../../assets/images/material-wear-house/icon-upload.png" alt="" class="up-icon" />
                                <span class="up-text">上传{{type == 1 ? '面料' : '辅料'}}图案</span>
                            </template>
                        </div>
                    </Upload>
                    <div class="main-form">
                        <div class="line-2-col">
                            <div class="line-2-col-item">
                                <div class="label required">名称:</div>
                                <input type="text" v-model="form.name" :placeholder="`请输入${type == 1 ? '面料' : '辅料'}名称`" />
                            </div>
                            <div class="line-2-col-item">
                                <div class="label">编号:</div>
                                <input type="text" v-model="form.no" :placeholder="`请输入${type == 1 ? '面料' : '辅料'}自定义编号`" />
                            </div>
                        </div>
                        <div class="line-2-col" v-if="type == 1">
                            <div class="line-2-col-item">
                                <div class="label">幅宽(cm):</div>
                                <input type="text" v-model="form.wide_width" placeholder="请输入面料幅宽,单位cm" />
                            </div>
                            <div class="line-2-col-item">
                                <div class="label">克重(g/㎡):</div>
                                <input type="text" v-model="form.weight" placeholder="请输入面料克重,单位g/㎡" />
                            </div>
                        </div>
                        <div class="line-1-col">
                            <div class="label">成分:</div>
                            <input type="text" v-model="form.component" :placeholder="`请输入${type == 1 ? '面料' : '辅料'}成分`" />
                        </div>
                         <div class="color-col">
                            <div class="color-form">
                                <div class="label">颜色:</div>
                                <div class="color-form-list">
                                    <div class="color-form-item" v-for="(item,index) in form.color" :key="`color-form-item-${index}`">
                                        <Upload action="/" :before-upload="(file)=>onColorImgUpload(file,index)">
                                            <img :src="item.image || require('../../../assets/images/material-wear-house/icon-upload-item-color.png')" alt="" class="up-ico" />
                                        </Upload>
                                        <input type="text" v-model="item.name" :placeholder="`输入${type == 1 ? '面料' : '辅料'}颜色`" />
                                        <img src="../../../assets/images/material-wear-house/icon-close-circle-gray.png" alt="" class="del-ico" @click="onColorDel(index)" />
                                    </div>
                                </div>
                            </div>
                            <div class="add-color-btn" @click="onAddColor">添加颜色</div>
                         </div>
                    </div>
                </div>
            </div>
            <div class="body-footer">
                <div class="cancel-btn" @click="onClose">取消</div>
                <div class="confirm-btn" @click="onSubmit">确认保存</div>
            </div>
        </div>
    </div>
</template>
<script>
import { AddOwnerMaterial, UpdateOwnerMaterial } from "@/api/index";
import { uploadFileToOSS } from "@/utils/oss";
export default{
    name:"AddFabric",
    props:{
        type:{
            type:String,
            default:""
        },
        material:{
            type:Object,
            default:()=>({})
        }
    },
    computed:{
        title(){
            return this.type == 1 ? '面料' : '辅料';
        }
    },
    data(){
        return{
            form:{
                name:"",
                no:"",
                wide_width:"",
                weight:"",
                component:"",
                color:[
                    {image:'',name:''}
                ]
            }
        }
    },
    mounted(){
        if(this.material && Object.keys(this.material).length > 0){
            console.log('this.material',this.material);
            // 使用深拷贝避免直接修改原对象
            this.form = JSON.parse(JSON.stringify(this.material));
            // 确保color数组存在
            if(!this.form.color || !Array.isArray(this.form.color)){
                this.$set(this.form, 'color', [{image:'',name:''}]);
            }
        }else{
            // 重置表单为默认值
            this.form = {
                name:"",
                no:"",
                wide_width:"",
                weight:"",
                component:"",
                color:[
                    {image:'',name:''}
                ]
            };
        }
    },
    methods:{
        async onSubmit(){
            try{
                console.log('form',{...this.form,type:this.type});
                // return;
                let response;
                if(this.form.uuid){
                    response = await UpdateOwnerMaterial({...this.form,type:this.type});
                }else{
                    response = await AddOwnerMaterial({...this.form,type:this.type});
                }
                const {code,msg} = response;
                if(code > 0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('成功添加~');
                this.onClose();
            }catch(e){
                console.log('err-add-fabric',e);
                this.$layer.msg(e.msg);
            }
        },
        onColorDel(index){
            if(this.form.color.length <= 1){
                this.$layer.msg('至少需设置一个颜色~');
                return;
            }
            this.form.color.splice(index,1);
        },
        onBeforeUpload(file){
            uploadFileToOSS(file).then(url=>{
                console.log('res==>',url);
                this.$set(this.form,'image',url);
            })
            return false;
        },
        onColorImgUpload(file,index){
            uploadFileToOSS(file).then(url=>{
                console.log('res==>',url);
                console.log('index',index);
                this.$set(this.form.color[index],'image',url);
            })
            return false;
        },
        onAddColor(){
            if(!Array.isArray(this.form.color)){
                this.$set(this.form,'color',[]);
            }
            this.form.color.push({image:'',name:''})
        },
        onClose(){
            this.$emit("close")
        }
    }
}
</script>
<style lang="scss" scoped>
.add-fabric{
    width:100vw;
    height:100vh;
    background:rgba(0,0,0,.5);
    position:fixed;
    top:0;
    left:0;
    display:flex;
    align-items:center;
    justify-content:center;
    z-index:119;
    user-select:none;
    .add-body{
        width:920px;
        background:#fff;
        border-radius:10px;
        position:relative;
        .close-btn{
            position:absolute;
            top:14px;
            right:16px;
            cursor:pointer;
            font-size:18px;
            // width:18px;
            // height:18px;
        }
        .body-title{
            width:100%;
            text-align:center;
            padding-top:20px;
            padding-bottom:12px;
            border-bottom:1px solid #e0e0e0;
            color:#0f1115;
            font-size:20px;
            font-weight:bold;
        }
        .body-content{
            width:100%;
            padding:20px 24px;
            .body-form{
                width:100%;
                background:#fafafa;
                border-radius:10px;
                padding:20px 24px 20px 20px;
                display:flex;
                column-gap:20px;
                .upload-main-img{
                    width:188px;
                    height:188px;
                    background:#fff;
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    flex-direction:column;
                    cursor:pointer;
                    .main-img{
                        width:100%;
                        height:100%;
                        object-fit:cover;
                        object-position:center;
                    }
                    .up-icon{
                        width:48px;
                        height:48px;
                    }
                    .up-text{
                        margin-top:8px;
                        color:#666;
                        font-size:14px;
                    }
                }
                .main-form{
                    flex:1;
                    display:flex;
                    flex-direction:column;
                    row-gap:12px;
                    .line-2-col{
                        display:flex;
                        column-gap:20px;
                        align-items:center;
                        .line-2-col-item{
                            flex:0 0 50%;
                            padding-bottom:12px;
                            border-bottom:1px solid #e3e3e3;
                            display:flex;
                            align-items:center;
                            .label{
                                color:#666;
                                font-size:14px;
                                &.required::after{
                                    content:"*";
                                    color:red;
                                }
                            }
                            input{
                                border:none;
                                outline:none;
                                background:transparent;
                            }
                        }
                    }
                    .line-1-col{
                        width:100%;
                        display:flex;
                        align-items:center;
                        padding-bottom:12px;
                        border-bottom:1px solid #e3e3e3;
                        .label{
                            color:#666;
                            font-size:14px;
                        }
                        input{
                            border:none;
                            outline:none;
                            background:transparent;
                        }
                    }
                    .color-col{
                        width:100%;
                        display:flex;
                        justify-content:space-between;
                        .color-form{
                            display:flex;
                            .label{
                                color:#666;
                                font-size:14px;
                                line-height:36px;
                                flex-shrink:0;
                            }
                            .color-form-list{
                                display:flex;
                                align-items:flex-start;
                                flex-wrap:wrap;
                                gap:5px;
                                .color-form-item{
                                    width:160px;
                                    height:36px;
                                    display:flex;
                                    align-items:center;
                                    column-gap:10px;
                                    border:1px solid #e3e3e3;
                                    border-radius:4px;
                                    padding:0 6px 0 8px;
                                    overflow:hidden;
                                    .up-ico{
                                        width:20px;
                                        height:20px;
                                        cursor:pointer;
                                    }
                                    input{
                                        border:none;
                                        outline:none;
                                        flex:1;
                                        max-width:84px;
                                    }
                                    .del-ico{
                                        width:16px;
                                        height:16px;
                                        cursor:pointer;
                                    }
                                }
                            }
                        }
                        .add-color-btn{
                            color:#0d99ff;
                            font-size:12px;
                            padding:0 10px;
                            border:1px solid #0d99ff;
                            border-radius:4px;
                            cursor:pointer;
                            height:24px;
                            line-height:24px;
                            flex-shrink:0;
                        }
                    }
                }
            }
        }
        .body-footer{
            width:100%;
            border-top:1px solid #e0e0e0;
            display:flex;
            align-items:center;
            justify-content:center;
            column-gap:10px;
            padding-top:18px;
            padding-bottom:22px;
            .cancel-btn{
                color:#666;
                font-size:14px;
                font-weight:bold;
                cursor:pointer;
                height:40px;
                line-height:40px;
                border:1px solid #e3e3e3;
                border-radius:4px;
                padding:0 36px;
            }
            .confirm-btn{
                color:#fff;
                font-size:14px;
                font-weight:bold;
                cursor:pointer;
                height:40px;
                line-height:40px;
                border:1px solid #e3e3e3;
                border-radius:4px;
                padding:0 40px;
                background:#ff5967;
            }
        }
    }
}

::v-deep .ivu-upload{
    display:flex;
    align-items:center;
}
</style>